import axios from 'axios';

const state = {};

const getters = {};

const actions = {
	// Posizionamento su Google della pagina di un prodotto in una lingua.
	// Ritorna { data } oppure { error: { message } }.
	fetchItem: async (context, payload) => {
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}searchconsole/item`,
				{ item: payload.item, altItem: payload.altItem || undefined, lang: payload.lang, keyword: payload.keyword || undefined, kind: payload.kind || undefined },
				{ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } },
			)
			.then(res => res.data)
			.catch(err => ({ error: err.response ? err.response.data : { message: err.message } }));
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
